import { Box, Flex, Tooltip } from "@shared/primitive-components"
import { scoreStyles as styles } from "../../styles"

export type ScoreProps = {
  score: number | null
  change?: number | null
  dataTestIds?: {
    SCORE?: string
    CHANGE?: string
  }
}

export const Score = ({ score, change, dataTestIds }: ScoreProps) => {
  if (score === null) return null
  return (
    <Flex>
      <Box css={styles.getScoreStyle(score)} data-testid={dataTestIds?.SCORE}>
        {Math.round(score)}
      </Box>
      {change !== null && change !== undefined && Math.round(change) !== 0 && (
        <Tooltip content="Change over a 30 day period">
          <Box css={styles.getScoreChangeStyle(change)} data-testid={dataTestIds?.CHANGE}>
            {change > 0 ? `+` : ``}
            {Math.round(change)}
          </Box>
        </Tooltip>
      )}
    </Flex>
  )
}

Score.defaultProps = {
  dataTestIds: undefined,
  change: null,
}
